import { LMFormatterService } from '@list/formatters';
import { AppConstants } from '@app/utils';

export const lmMaskOptionsFunction = (
  lmFormatterService: LMFormatterService,
  row: number,
  cell: number,
  value: any,
  columnDef: ListGridColumn,
  dataView: LMListDataView
): SohoMaskOptions => {

  if (!columnDef || columnDef.displayField.type !== AppConstants.BCD) {
    return;
  }

  const decSize: number = columnDef.displayField.decSize;
  const targetDataView = lmFormatterService.listSpec.isTemplateList ? dataView.dataView : dataView;
  const precision: number = lmFormatterService.getDisplayFieldPrecision(columnDef.displayField, targetDataView);

  const allowDecimal: boolean = (decSize !== undefined && decSize > 0);
  const decimalLimit: number = (allowDecimal)
    ? (precision < decSize) ? precision : decSize
    : 0;
  const integerLimit: number = (allowDecimal) ? columnDef.displayField.size - decimalLimit : columnDef.displayField.size;

  const maskOptions: SohoMaskOptions = {
    process: 'number',
    patternOptions: {
      allowDecimal,
      allowNegative: !columnDef.displayField.positiveOnly,
      integerLimit,
      decimalLimit,
      allowLeadingZeros: true,
      allowThousandsSeparator: false,
      symbols: {
        decimal: Soho.Locale.numbers().decimal,
        negative: Soho.Locale.numbers().minusSign,
        thousands: Soho.Locale.numbers().group
      }
    }
  };

  return maskOptions;
};
